// To remove underscores and capitalize the first letter of a string
export const formatString = (str: string) => {
    return str.toLowerCase().replace(/_/g, ' ')
        .replace(/(?: |\b)(\w)/g, function (key, p1) {
            return key.toUpperCase();
        })
}